var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({width: _vm.width})},[_c('v-progress-linear',{attrs:{"height":"20","rounded":"","value":_vm.percentual,"color":_setup.style.color}},[_c('strong',{class:_setup.style.textColor},[_vm._v(_vm._s(_vm.percentual)+"%")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }